import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  fonts,
  fontSizes,
  colors,
  radii,
} from "@softmax/design-system/tokens.stylex";

export const styles = stylex.create({
  stack: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space12,
    minWidth: 0,
  },
  prose: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space6,
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
    lineHeight: 1.45,
    color: colors.muted,
  },
  paragraph: { margin: 0 },
  emphasis: { fontWeight: 500, color: colors.foreground },
  nowrap: { whiteSpace: "nowrap" },
  keyboard: {
    borderRadius: radii.small,
    backgroundColor: colors.hover,
    paddingInline: spacing.space6,
    paddingBlock: spacing.space2,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    color: colors.foreground,
  },
});
